export function extractBlob(payload) {
    if (!payload) {
        throw new Error("Файл олдсонгүй");
    }

    if (payload instanceof Blob) {
        return payload;
    }

    if (payload?.blob instanceof Blob) {
        return payload.blob;
    }

    if (payload?.data instanceof Blob) {
        return payload.data;
    }

    if (payload?.file instanceof Blob) {
        return payload.file;
    }

    throw new Error("Файлын өгөгдөл буруу байна");
}

export function openBlobInNewTab(payload) {
    const blob = extractBlob(payload);
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank", "noopener,noreferrer");

    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 2000);
}

export function saveBlob(payload, fileName = "download.pdf") {
    const blob = extractBlob(payload);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 1000);
}